'use client'

// The in-editor element inspector enumerates React component props on
// hover/click, which touches the `params`/`searchParams` Promise props that
// Next.js injects into page components. Next then logs sync-dynamic-apis
// warnings whose stack traces end in anonymous devtools listeners
// (mousemoveListener/clickListener) rather than app code. Our own pages
// unwrap these props correctly (see app/sign-in/[[...sign-in]]/page.tsx),
// so these specific messages are pure noise in development.
//
// Dev-only and message-specific: production builds and all other console
// errors are untouched.
const SUPPRESSED_MESSAGES = [
  'params are being enumerated. `params` is a Promise',
  'The keys of `searchParams` were accessed directly. `searchParams` is a Promise',
]

if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  const originalError = console.error
  console.error = (...args: unknown[]) => {
    const first = args[0]
    if (
      typeof first === 'string' &&
      SUPPRESSED_MESSAGES.some((msg) => first.includes(msg))
    ) {
      return
    }
    originalError(...args)
  }
}

export function SuppressInspectorWarnings() {
  return null
}
